import { Component, DestroyRef, OnInit, computed, inject, input, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";
import { KENDO_COMBOBOX } from "@progress/kendo-angular-dropdowns";
import { EditAirport } from "../../../form/flight-edit-lookups";
import { FlightGroup } from "../../../form/flight-form-group";
import { ChangedFieldDirective } from "../../../changed-field.directive";

@Component({
    selector: "app-leg-group",
    imports: [ChangedFieldDirective, ReactiveFormsModule, TranslatePipe, KENDO_COMBOBOX],
    templateUrl: "./leg-group.component.html",
    styleUrl: "../../../edit-fields.scss",
})
export class LegGroupComponent implements OnInit {
    private readonly destroyRef = inject(DestroyRef);

    readonly group = input.required<FlightGroup>();
    /** The airports to choose from, each list with the place the flight already has. */
    readonly departures = input.required<EditAirport[]>();
    readonly arrivals = input.required<EditAirport[]>();
    /** A ground run has one place, for the departure and the arrival. */
    readonly groundRun = input(false);

    private readonly departureId = signal<number | null>(null);
    private readonly arrivalId = signal<number | null>(null);

    /** The airports the leg has chosen, whose code, city and name show under their fields, as in the app. */
    readonly departure = computed(() => this.departures().find((airport) => airport.id === this.departureId())?.airport ?? null);
    readonly arrival = computed(() => this.arrivals().find((airport) => airport.id === this.arrivalId())?.airport ?? null);

    ngOnInit(): void {
        const { departureId, arrivalId } = this.group().controls;
        this.departureId.set(departureId.value);
        this.arrivalId.set(arrivalId.value);
        departureId.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => this.departureId.set(value));
        arrivalId.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => this.arrivalId.set(value));
    }
}
